import type { FC } from "react"

import { formatNumber } from "@/utils/number"

interface AdjustmentHistoryQuantityChangeCellProps {
  qtyChange?: number | null
}

export const AdjustmentHistoryQuantityChangeCell: FC<AdjustmentHistoryQuantityChangeCellProps> = ({ qtyChange }) => {
  if (qtyChange === null || qtyChange === undefined) return null

  const formatted = formatNumber(qtyChange, 2, 2)

  if (qtyChange > 0) return <span className='text-tertiary-green-900'>+{formatted}</span>

  if (qtyChange < 0) return <span className='text-red-600'>{formatted}</span>

  return formatted
}
